import { BaseDto } from '../base.dto';
import { EntityTypeDto } from '../entityType.dto';
import { GiftCardDto } from './giftCard.dto';
import { MerchantDto } from '../merchant.dto';

export class GiftCardTransactionDto extends BaseDto {
  giftCard?: GiftCardDto;
  merchant?: MerchantDto;
  amount: number;
  entityId?: number;
  entityType?: EntityTypeDto;
  userId?: number;
  active?: boolean;
}
